import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Wordmark } from "@/components/Logo";

export const AuthShell = ({ title, subtitle, children, footer }) => {
  return (
  <div className="min-h-screen grid md:grid-cols-2 bg-[#FAF7F2]">
    <div className="flex flex-col px-4 sm:px-8 lg:px-16 py-8">
      <Link to="/" data-testid="auth-logo-link"><Wordmark className="h-20" /></Link>
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }} className="flex-1 flex flex-col justify-center max-w-md w-full mx-auto py-12">
        <div className="md:hidden mx-auto mb-8 w-44 sm:w-52 arch overflow-hidden border-4 border-white shadow-[0_24px_48px_-24px_rgba(28,25,23,0.45)]" data-testid="auth-kids-image-mobile">
          <img src="/images/kids-reading.jpg" alt="" className="w-full aspect-[4/5] object-cover object-center" />
        </div>
        <h1 className="font-display text-4xl lg:text-5xl font-bold mb-3">{title}</h1>
        <p className="text-stone-600 mb-8">{subtitle}</p>
        {children}
        <div className="mt-8 text-sm text-stone-700">{footer}</div>
      </motion.div>
    </div>
    <div className="relative hidden md:flex flex-col items-center justify-center gap-6 overflow-hidden bg-[#FBF8F1] border-s border-[#E5DCCB] px-6 lg:px-12 py-10">
      <motion.div initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }} className="arch overflow-hidden border-[6px] border-white shadow-[0_40px_80px_-30px_rgba(28,25,23,0.4)] w-full max-w-sm">
        <img src="/images/kids-reading.jpg" alt="" data-testid="auth-kids-image" className="w-full max-h-[62vh] object-cover object-center" />
      </motion.div>
    </div>
  </div>
  );
};

export const Field = ({ label, children }) => (
  <label className="block space-y-2">
    <span className="text-sm font-semibold text-stone-800">{label}</span>
    {children}
  </label>
);

export const inputCls = "w-full h-12 px-4 bg-white border border-[#E5DCCB] rounded-sm focus:outline-none focus:border-[#8B3A2B] focus:ring-2 focus:ring-[#8B3A2B]/15 transition-colors";
export const submitCls = "w-full h-12 rounded-full bg-[#1C1917] text-[#FAF7F2] font-semibold hover:bg-[#8B3A2B] transition-colors disabled:opacity-60";
